//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('operationFactories', {
//        templateUrl: 'views/components/views/operationFactories/operationFactories.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'operationFactoriesService', function ($stateParams, utilityService, operationFactoriesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                setting: {},
//                itemsListOperationFactories: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await operationFactoriesService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];

//                return loadOperationFactories();
//            }

//            async function loadOperationFactories() {
//                if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

//                return vm.model.itemsListOperationFactories = await operationFactoriesService.listOperationFactories({
//                    argtype: vm.model.setting.argtype,
//                    argvalue: vm.model.setting.argvalue
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            }

//		    // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
